import React from "react";

const OverviewAIR = () => {
  return (
    <div className="flex md:space-x-2">
      <div className="md:w-3/4">
        <div className="border-2 p-2 border-sdorange inline-block mb-1 ">
          <p>Course Overview</p>
        </div>
        <div>
          <img src="/image-fix/random-images/advanced-international-relations.jpg" />
        </div>
        <div id="overview">
          <p className="text-justify">
            The Postgraduate Diploma in Advanced International Relations and
            Diplomatic Practice is an intensive programme designed to equip
            participants with advanced diplomatic knowledge and skills.
            Combining theoretical insights with hands-on experiences like
            simulations and case studies, this 60- ECTS programme enables
            students to navigate complex global challenges effectively.
            Participants will explore international relations theories,
            diplomatic negotiation, foreign policy analysis, and global
            governance frameworks. With a focus on cross-cultural communication,
            conflict resolution, and innovative practices like science
            diplomacy, graduates will be prepared for impactful roles in
            international organisations, government agencies, and global
            corporations, or for further academic pursuits in diplomacy and
            global affairs.
          </p>
        </div>
        <div className="border-2 p-2 border-sdorange inline-block mb-1 mt-4 ">
          <p>Course Aim</p>
        </div>
        <div>
          <p>
            The primary aim of the Advanced International Relations & Diplomatic
            Practice Course is to equip students with advanced knowledge &
            practical skills essential for successful diplomacy in contemporary
            international relations. By delving deeper into diplomatic theory &
            practice, participants will gain a comprehensive understanding of
            the complexities involved in modern diplomacy.
          </p>
        </div>
      </div>
      <div className="md:w-1/4 hidden p-2 rounded-lg border-2 border-sdorange bg-sdbodywhiteywhitebodyywhitebody md:flex items-center">
        {" "}
        <img
          src="/image-fix/academic-programmes/executive-education/schima.png"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default OverviewAIR;
